export const PASSWORD_HELP_TEXT = `Insira uma combinação de pelo menos 11 caracteres. Sua senha deve conter
                                  pelo menos uma letra maiúscula, uma letra minúscula, um número, sinais de pontuação
                                  e símbolos (como ! # % . / *)`
